<template>
  <button
    type="button"
    :class="`btn ${fullWidth?'w-100':''} ${addClass}`"
    :style="cssString"
    :disabled="disabled || loading || hasUnresolvedDependencies"
    @click="clicked"
  >
    <div class="buttonText" :style="textCssString" v-if="!loading">
      {{ $t(updatedText) }}
    </div>
    <div
      v-else
      role="status"
    >
      <span v-if="uploadPercentage">{{ uploadPercentage + '%' }}</span>
      <div v-else class="spinner-border spinner-border-sm">
        <span class="sr-only"></span>
      </div>
    </div>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "button-component",
  data () {
    return {
      loading: false,
      cssString: "",
      textCssString: "",
      updatedText: ""
    };
  },
  props: {
    id: {
      type: String
    },
    requires: {
      type: Array
    },
    grid: {
      type: Object,
      required: false,
      default: () => {}
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "#000"
    },
    borderColor: {
      type: String,
      required: false,
      default: "#000"
    },
    textColor: {
      required: false,
      type: String,
      default: "#fff"
    },
    text: {
      required: false,
      type: String,
      default: "Button"
    },
    borderRadius: {
      required: false,
      type: String,
      default: "0"
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    enabledOn:{
      required: false,
      type:String,
      default:''
    },
    fullWidth: {
      type: Boolean
    },
    action: {
      type: [Object, Array]
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    textStyles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    addClass: {
      type: String,
      default: ""
    }
  },
  watch: {
    styles: {
      immediate: true,
      handler () {
        const keys = Object.keys(this.styles);
        const vals = Object.values(this.styles);
        keys.forEach((key, idx) => (this.cssString += key + ":" + vals[idx]));
        const txtkeys = Object.keys(this.textStyles);
        const txtvals = Object.values(this.textStyles);
        txtkeys.forEach((key, idx) => (this.textCssString += key + ":" + txtvals[idx]));
      }
    },
    enabledOn:{
      immediate:true,
      handler (val){
        if(!val || val ==''){
          return
        }
        return this.$store.state[val]
      }
    },
    signedUp: {
      handler (val, oldVal) {
        if (this.id === 'voucherBtn') {
          if (val) {
            this.updatedText = this.$t('Get Voucher For A Friend')
          } else {
            this.updatedText = this.text;
          }
        }
      }
    }
  },
  mounted () {
    this.updatedText = this.text;
  },
  computed: {
    ...mapGetters(['uploadPercentage', 'signedUp']),
    hasUnresolvedDependencies () {
      return this.$store.getters.hasUnresolvedDependencies(this.requires);
    }
  },
  methods: {
    async clicked () {
      if (!this.action) {
        return;
      }
      if(this.action.anchor){
        return window.location.href = this.$te(this.action.link) ? this.$t(this.action.link) : this.action.link
      }
      if (this.action.length > 0) {
        for (let i = 0; i < this.action.length; i++) {
          const act = this.action[i];
          const fn = act.fn;
          const params = act.params;
          await this[fn](params, this);
        }
        return;
      }
      const fn = this.action.fn;
      const params = this.action.params;
      await this[fn](params, this);
      // const params = this.action.params.toString();
      // eval(`this.${this.action.fn}(params)`);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  margin: 5px;

  &:focus,
  &:active {
    outline: none !important;
    box-shadow: none;
  }
}

.btn {
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: black;
  border: 1px solid transparent;
  border-radius: var(--button-radius);
  transition: all 0.3s;
  box-sizing: border-box;
  font-size: 18px;
  letter-spacing: 0.18px;
  line-height: 21px;
  text-align: center;
  padding: 15px 5px;
  text-transform: uppercase;
  width: 100%;
  @media (max-width: 712px) {
    font-size: 13px;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  }
  &_disabled {
    opacity: 0.7;
  }
  &-next {
    background-color: var(--button-color-1);
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: #FFFFFF;
    &:hover {
      background-color: var(--button-hover-1);
    }
    &:disabled {
      opacity: .5;
    }
  }
  &-back {
    font-size: 16px;
    line-height: 22px;
    background-color: var(--button-color-2);
    color: #FFFFFF;
    font-weight: 500;
    &:hover {
      background-color: var(--button-hover-2);
    }
    &:disabled {
      opacity: .5;
    }
  }
}

</style>